import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { InputAdornment, TextField } from '@mui/material';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

interface NotificationSearchProps {
  value: string;
  onChange: (value: string) => void;
}

export const NotificationSearch = memo(function NotificationSearch({
  value,
  onChange,
}: NotificationSearchProps) {
  const { t } = useTranslation('entity-portal');

  return (
    <TextField
      value={value}
      onChange={(event) => onChange(event.target.value)}
      placeholder={t('notificationCenter.searchPlaceholder')}
      fullWidth
      size="small"
      aria-label={t('notificationCenter.searchLabel')}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchOutlinedIcon fontSize="small" color="action" />
          </InputAdornment>
        ),
      }}
    />
  );
});
